import { render, staticRenderFns } from "./TierApplicableYearInput.vue?vue&type=template&id=3cca6bf5&"
import script from "./TierApplicableYearInput.vue?vue&type=script&lang=js&"
export * from "./TierApplicableYearInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports